/**
 * Module metadata registry. Thin layer: list from generated-module-registry,
 * metadata from @korvo/core. No hardcoded module list.
 * See docs/DERIVATIVE_PROJECTS.md and docs/CODE_QUALITY.md.
 */

import { generateModuleMetadata } from '@korvo/core/derivative-app/module-metadata';
import { type ModuleRegistration } from '@korvo/core/types/module-boundaries';

import { moduleDescriptorPartials } from './generated-module-protocol-registration';
import { getAppModules } from './generated-module-registry';

/** RAG and workspace are infrastructure; they stay enabled for routes but do not get standalone `/home` module tiles. */
const customMetadata: Record<string, Partial<Omit<ModuleRegistration, 'id'>>> = {
  rag: { showOnAppHome: false },
  workspace: { showOnAppHome: false },
};

export const moduleMetadataRegistry: ModuleRegistration[] = generateModuleMetadata(
  getAppModules(),
  customMetadata,
  moduleDescriptorPartials
);

export function getModuleById(id: string): ModuleRegistration | undefined {
  return moduleMetadataRegistry.find(module => module.id === id);
}

export function isModuleAvailable(moduleId: string): boolean {
  return moduleMetadataRegistry.some(module => module.id === moduleId);
}
